// 后端通用类型定义
//
// 所有接口外层包一个 ComBaseResponse；data 字段才是业务数据。
// 业务成功 = code === 0；否则把 detail 弹给用户看。

export interface ApiEnvelope<T> {
  code: number;
  msg: string;
  /** 用户可见错误消息（i18n 过的），优先于 msg 展示 */
  detail?: string;
  data: T;
}

/** 分页信息，所有列表型响应都嵌一个 */
export interface Page {
  count: number;
  page_no: number;
  page_size: number;
}

/** 列表型响应的统一壳 */
export interface PagedList<T> {
  list: T[];
  page: Page;
}

/** 业务错误。axios interceptor 在 code !== 0 时 throw 这个 */
export class ApiError extends Error {
  constructor(
    public readonly code: number,
    public readonly detail: string,
    public readonly raw?: unknown,
  ) {
    super(detail || `API error ${code}`);
    this.name = "ApiError";
  }
}
